module.exports = __webpack_public_path__ + "img/perfil.c4ae0825.png";